<template>
    <div>
        <!-- 头部-->
        <div class="city-child-head">
            <!-- 标题 -->
            <div class="city-child-head-left float-l">
                <div class="city-child-head-icon"></div>
                <span>用户规模</span>
            </div>
        </div>
        <!-- 内容 -->
        <div class="city-content city-content-chunk-box d-flex">
            <div :class="['d-flex', 'content-item', `content-bgm${index}`]" v-for="(item, index) in pageList" :key="index">
                <div>
                    <div class="t-text">{{ item.num }}</div>
                    <div class="t-title">{{ item.name }}</div>
                </div>
                <div v-if="index < 3">
                    <div class="t-text">{{ item.data }}</div>
                    <div class="t-title">{{ item.title }}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getSystemTotalMsg } from '../../api/holdMy.js';
export default {

    data() {
        return {
            refreshImgIng: null,   // 刷新定时器
            pageList: [{
                num: 0,
                name: '项目总数',
                data: 0,
                title: '近30天活跃项目',
            }, {
                num: 0,
                name: '入网车辆总数',
                data: 0,
                title: '近30天活跃车辆',
            }, {
                num: 0,
                name: '司机总数',
                data: 0,
                title: '近30天活跃司机',
            }, {
                num: 0,
                name: '机械',
            }, {
                num: 0,
                name: '服务商'
            }],
            getData: {
                cityName: this.$route.query.cityName,
                city: this.$route.query.cityName,
            },
        }
    },
    components: {},
    created() {

    },
    mounted() {
        this.refreshScale();
    },

    beforeDestroy() {
        clearInterval(this.refreshImgIng);
    },
    methods: {
        // 刷新数据
        refreshScale() {
            this.systemTotalMsg();
            this.refreshImgIng = setInterval(() => {
                this.systemTotalMsg();
            }, 1000 * 60 * 30)
        },
        // 获取系统统计
        systemTotalMsg() {
            getSystemTotalMsg({ ...this.getData }).then(res => {
                if (res.result == 0) {
                    this.pageList[0].num = res.userdata.systemSubitemEntryCount || 0; // 项目总数
                    this.pageList[0].data = res.userdata.systemSubitemBriskCount || 0; // 近30天活跃项目
                    this.pageList[1].num = res.userdata.systemVehicleEntryCount || 0; // 入网车辆总数
                    this.pageList[1].data = res.userdata.systemVehicleBriskCount || 0; // 近30日活跃司机数量
                    this.pageList[2].num = res.userdata.systemDriverEntryCount || 0; // 司机总数
                    this.pageList[2].data = res.userdata.systemDriverBriskCount || 0; //近30日活跃司机数量
                    this.pageList[3].num = 0; // 机械
                    this.pageList[4].num = 0; // 商务服务
                }
            }).catch(error => {
                console.log(error);
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.city-content {
    flex-direction: column;
    align-items: center;
    flex-flow: wrap;
    padding: 13px 8px 0px 8px;
    height: 283px;

    .content-item {
        .t-text {
            font-size: 26px;
            line-height: 32px;
        }

        .t-title {
            font-size: 12px;
        }
    }

    .content-item {
        width: 233px;
        height: 55px;
        display: flex;
        text-align: center;
        align-content: center;
        justify-content: space-around;
        font-family: '微软雅黑', sans-serif;
        font-weight: 400;
        font-style: normal;
        color: #FFFFFF;
        margin-bottom: 13px;
    }

    .svg-file2 {
        position: absolute;
        top: 7%;
        left: 8%;
    }

    .svg-file {
        position: absolute;
        top: 7%;
        left: 8%;
    }

    .svg-file-1 {
        position: absolute;
        top: 18%;
        left: 24%;
        font-size: 40px;
    }

    .bg-svg {
        display: block;
        width: 65px;
        height: 65px;
        -webkit-animation: rotation 4s linear infinite;
        animation: rotation 4s linear infinite;
    }

    @each $animal in 0,
    1,
    2,
    3,
    4 {
        .content-bgm#{$animal} {
            background: url("~@/assets/icons/userScale#{$animal}.png") no-repeat;
            background-size: cover;
            background-position: center;
            padding-left: 55px;

            @if $animal >2 {
                width: 113px;

                .t-title {
                    font-size: 10px;
                }
            }

            @if $animal ==3 {
                margin-right: 6px;
            }
        }
    }

    @keyframes rotation {
        0% {
            -webkit-transform: rotate(0deg);
        }

        100% {
            -webkit-transform: rotate(360deg);
        }
    }
}
</style>